module.exports = __webpack_public_path__ + "static/media/kanbanDnClose.b77669d1.mp3";